import { useEffect, useState, type ReactNode } from 'react'
import '../startup-loader-reference.css'
import '../startup-loader-orbit.css'

const MIN_VISIBLE_MS = 3200
const EXIT_MS = 420

export function StartupLoadingGate({ ready, children }: { ready: boolean; children: ReactNode }) {
  const [mode] = useState(() => {
    const query = new URLSearchParams(window.location.search)
    const preview = query.get('previewLoader') === '1'
    return {
      enabled: query.get('postLogin') === '1' || preview,
      preview,
    }
  })
  const [minimumElapsed, setMinimumElapsed] = useState(false)
  const [leaving, setLeaving] = useState(false)
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    if (!mode.enabled || mode.preview) return

    const timer = window.setTimeout(() => setMinimumElapsed(true), MIN_VISIBLE_MS)
    return () => window.clearTimeout(timer)
  }, [mode.enabled, mode.preview])

  useEffect(() => {
    if (mode.preview || !mode.enabled || !minimumElapsed || !ready) return

    const startExit = window.setTimeout(() => setLeaving(true), 100)
    const finishExit = window.setTimeout(() => {
      const url = new URL(window.location.href)
      url.searchParams.delete('postLogin')
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`)
      setHidden(true)
    }, 100 + EXIT_MS)

    return () => {
      window.clearTimeout(startExit)
      window.clearTimeout(finishExit)
    }
  }, [mode.preview, mode.enabled, minimumElapsed, ready])

  if (!mode.enabled || hidden) return <>{children}</>

  return (
    <>
      {children}
      <div className={`startup-loader${leaving ? ' is-leaving' : ''}`} role="status" aria-busy="true" aria-live="polite">
        <div className="startup-loader__side-rings startup-loader__side-rings--left" aria-hidden="true" />
        <div className="startup-loader__side-rings startup-loader__side-rings--right" aria-hidden="true" />

        <div className="startup-loader__content">
          <div className="startup-loader__emblem loader-orbit" aria-hidden="true">
            <div className="orbit-dashed" />
            <div className="orbit-ring orbit-ring-primary" />
            <div className="orbit-ring orbit-ring-secondary" />
            <span className="orbit-dot dot-1" />
            <span className="orbit-dot dot-2" />
            <span className="orbit-dot dot-3" />
            <span className="orbit-dot dot-4" />
            <div className="loader-center">
              <img src="/loader-icon.svg" alt="" />
            </div>
          </div>

          <h1>SUITE DE PROCEDIMENTOS</h1>
          <span className="startup-loader__accent" aria-hidden="true" />
          <p className="startup-loader__environment">AMBIENTE DE ATENDIMENTO</p>
          <p className="startup-loader__welcome">Bem-vindo(a)!</p>
          <p className="startup-loader__preparing">Preparando sua experiência...</p>
          <p className="startup-loader__helper">Aguarde alguns instantes enquanto organizamos tudo para você.</p>

          <div className="startup-loader__dots" aria-hidden="true">
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>

          <span className="startup-loader__sr-only">Carregando Suite de Procedimentos.</span>
        </div>
      </div>
    </>
  )
}
